import { render, staticRenderFns } from "./JjEditorTool.vue?vue&type=template&id=2d4686c8&scoped=true"
import script from "./JjEditorTool.vue?vue&type=script&lang=js"
export * from "./JjEditorTool.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./JjEditorTool.vue?vue&type=style&index=1&id=2d4686c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4686c8",
  null
  
)

export default component.exports